export class ActionButton {
  action: (input: string) => string;
  name: string;

  constructor(name: string, action: (input: string) => string) {
    this.name = name;
    this.action = action;
  }
}
